
    <mat-dialog-content>
        <p><strong>{{header}}</strong></p>
        <p style="white-space: pre-line; text-align:left">{{content}}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="yesButton" fxFlexAlign="flex-start" (click)="Confirm()">Ok</button>
    </mat-dialog-actions>

